//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/NXObject.js";
let d=[[[0,"ComponentGroup",0,"Assemblies.ComponentGroup",0],[0,"Description",0,0],[0,"HasSpoolAssembly",0,0],[0,"LastPublishDate",0,0],[0,"Name",0,0],[0,"SpoolAssemblyFileName",0,0],[0,"SpoolAssemblyStatus",0,0],[0,"ViewSet",0,"ViewSet",0]],[[["numberOfMembers"],"GetMembers",{R_:{members:"Assemblies.Component[]"}},0,0],[["object"],"HasMember",{R_:{hasMember:''}},1,0]],[]];
SPLM.MechanicalRouting.Spool = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.Spool";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.Spool.SpoolAssemblyPublishStatus = Object.freeze({
    "Unknown" : "Unknown", "UpToDate" : "UpToDate", "OutOfDate" : "OutOfDate"});

export default SPLM;